// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2K2DI","savePackageButton":"ClientWallet_savePackageButton__140K9"};